export default {
  state: { data: {} },
  mutations: {
    setEmailToLOData(state, data) {
      state.data = data;
    }
  },
  actions: {}
};
